"use strict";
// Inspiration form here: See this: https://getbootstrap.com/docs/4.0/utilities/spacing/
Object.defineProperty(exports, "__esModule", { value: true });
exports.paddingClasses = exports.marginClasses = exports.padding = exports.margin = exports.spacingLevels = void 0;
var tslib_1 = require("tslib");
// 4, 8, 16, 24, 32, 40, 48, 64, 80, 128px
exports.spacingLevels = {
    '0': '0',
    '4': '0.25rem',
    '8': '0.5rem',
    '12': '0.75rem',
    '16': '1rem',
    '24': '1.5rem',
    '32': '2rem',
    '40': '2.5rem',
    '48': '3rem',
    '64': '4rem',
    '80': '5rem',
    '128': '8rem',
    auto: 'auto',
};
var variants = function (value, prefix) { return ({
    a: prefix + ": " + value + ";",
    l: prefix + "-left: " + value + ";",
    r: prefix + "-right: " + value + ";",
    b: prefix + "-bottom: " + value + ";",
    t: prefix + "-top: " + value + ";",
    x: prefix + "-left: " + value + "; " + prefix + "-right: " + value + ";",
    y: prefix + "-top: " + value + "; " + prefix + "-bottom: " + value + ";",
}); };
/**
 * Usage:
 *   margin["16"].b,
 *   padding["4"].a,
 *   margin["auto"].x
 *   etc..
 */
exports.margin = Object.entries(exports.spacingLevels).reduce(function (a, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    return (tslib_1.__assign(tslib_1.__assign({}, a), (_b = {}, _b[key] = variants(value, 'margin'), _b)));
}, {});
exports.padding = Object.entries(exports.spacingLevels).reduce(function (a, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    return (tslib_1.__assign(tslib_1.__assign({}, a), (_b = {}, _b[key] = variants(value, 'padding'), _b)));
}, {});
exports.marginClasses = Object.entries(exports.margin)
    .flatMap(function (_a) {
    var level = _a[0], values = _a[1];
    return Object.entries(values).map(function (_a) {
        var variant = _a[0], res = _a[1];
        return ".m" + variant + "-" + level + " { " + res + " }";
    });
})
    .join('\n');
exports.paddingClasses = Object.entries(exports.padding)
    .flatMap(function (_a) {
    var level = _a[0], values = _a[1];
    return Object.entries(values).map(function (_a) {
        var variant = _a[0], res = _a[1];
        return ".p" + variant + "-" + level + " { " + res + " }";
    });
})
    .join('\n');
//# sourceMappingURL=margins.js.map